import React from 'react';
import cn from 'classnames';

export function PageContent({
  className,
  ...divProps
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('overflow-auto h-full p-5 xl:p-6', className)}
      {...divProps}
    />
  );
}

export type PageProps = React.HTMLAttributes<HTMLDivElement> & {
  withoutTwp?: boolean;
};

export function Page({
  withoutTwp = false,
  className,
  ...divProps
}: PageProps) {
  return (
    <div
      className={cn(
        !withoutTwp && 'twp',
        'flex flex-col w-full h-full',
        className,
      )}
      {...divProps}
    />
  );
}
